"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SECTIONS = void 0;
var SECTIONS = {
    ACCOUNT: 'account',
    PLAYER: 'player',
    INTERFACE: 'interface',
    ABOUT: 'about',
};
exports.SECTIONS = SECTIONS;
